<template>
  <div class="gauge">
    <div class="gauge__wrapper gauge__wrapper--bar">
      <div v-for="segment in segments" :class="segmentStyles(segment)">
        <span v-if="value === segment || segment <= value" class="gauge__fill" aria-hidden="true"></span>
        <span class="sr-only">{{ segment }}<span v-if="value === segment"> (Current)</span></span>
      </div>
    </div>
    <div class="gauge__wrapper gauge__wrapper--labels">
      <div v-for="label in labels" class="gauge__label">
        {{ label }}
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      labels: {
        type: Array,
        default() {
          return [];
        },
      },

      value: {
        type: Number,
        default: 0,
      },
    },

    data() {
      return {
        segments: [5, 4, 3, 2, 1],
      };
    },

    computed: {
      segmentStyles() {
        return (segment) => {
          return {
            'gauge__segment': true,
            'gauge__segment--current': segment === this.value,
            'gauge__segment--filled': segment <= this.value,
          };
        };
      },
    },
  };
</script>
